import {useEffect, useState} from "react";
import {agent} from "../../../api/agent";
import LoadingContainer from "../../LoadingContainer";
import styled from "styled-components";
import SearchInput from "../../Search/SearchInput";
import TaskPermissions from "./TaskPermissions";

interface Props {
    permissions: string[];
    onChange: (permissions: string[]) => void;
}

const Server = styled.div`

    cursor: pointer;
    padding: .5rem 1.5rem;
    
    &:hover {
        background-color: var(--content-box-hover);
    }
    
    h2 {
        margin: 0;
        font-size: 1.2rem;
    }
`;

const Back = styled.div`
    cursor: pointer;
    padding: .5rem .5rem;

    &:hover {
        background-color: var(--content-box-hover);
    }
    
    span {
        margin-left: .5rem;
        font-size: 1.2rem;
    }
    
`;

interface Server {
    id: string;
    name: string;
    amount: number;
}

export default function TaskList(props: Props) {

    const [servers, setServers] = useState<Server[]>([]);
    const [filteredServers, setFilteredServers] = useState<Server[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [selectedServer, setSelectedServer] = useState<string | null>(null);

    const load = () => {
        setLoading(true);
        agent.getTasks().then(repos => {
            setLoading(false);
            setServers(repos.map(repo => {
                return {
                    id: repo.id,
                    name: repo.name,
                    amount: props.permissions.filter(value => value.startsWith("task."+repo.id+".")).length
                }
            }).sort((a, b) => b.amount - a.amount));
        });
    }

    useEffect(() => {
        load();
    }, []);

    return (
        <LoadingContainer open={loading}>
            {!selectedServer && (<>
                <SearchInput data={servers} setSearchResult={setFilteredServers} searchableKeys={['name']}></SearchInput>
                {filteredServers.map(deployment => (
                    <Server key={deployment.id} style={{cursor: 'pointer'}} onClick={() => {
                        setSelectedServer(deployment.id);
                    }}>
                        <h2 style={{display: 'inline-block'}}>{deployment.name}</h2>
                        <span style={{float: 'right'}}>{deployment.amount} Permissions set</span>
                    </Server>
                ))}
            </>)}
            {selectedServer && (
                <div>
                    <Back style={{cursor: 'pointer'}} onClick={() => {
                        load();
                        setSelectedServer(null);
                    }}>
                        <i className="fa-solid fa-angle-left"></i>
                        <span>Selected Repo: {servers.find(value => value.id === selectedServer)?.name}</span>
                    </Back>

                    <TaskPermissions permissions={props.permissions} onChange={props.onChange} server={selectedServer}></TaskPermissions>
                </div>
            )}

        </LoadingContainer>
    )



}

